import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { Button, Form, Stack } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { checkEmailAction, resetRegisterAction } from "@redux/actions";
import { initialValues, validateSchema } from "./SignUpData";
import { InputField } from "@components";
import styles from "./styles/SignUp.module.css";
import { useEffect, useLayoutEffect } from "react";
import { APP_TITLE_SUFFIX } from "@constants";

const SignUp = () => {
  // state

  // variables
  const inputFields = [
    { name: "fullname", type: "text", placeholder: "Full Name" },
    { name: "email", type: "email", placeholder: "Email Address" },
    {
      name: "password",
      type: "password",
      placeholder: "Password",
    },
    {
      name: "confirmPassword",
      type: "password",
      placeholder: "Password confirmation",
    },
  ];

  // hooks
  const { emailChecker, register } = useSelector((state) => state.auth);
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldError,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: state || initialValues,
    validationSchema: validateSchema,
    onSubmit: (values) => dispatch(checkEmailAction(values)),
  });

  // logics

  // UI partials
  const signUpForm = (
    <Form noValidate onSubmit={handleSubmit}>
      <Stack gap={4}>
        {inputFields.map((field, index) => (
          <Form.Group key={index} controlId={field.name}>
            <InputField
              name={field.name}
              type={field.type}
              placeholder={field.placeholder}
              value={values[field.name]}
              onChange={handleChange}
              onBlur={handleBlur}
              touchedValue={touched[field.name]}
              errorsValue={errors[field.name]}
            />
          </Form.Group>
        ))}
        <Form.Group controlId="submit">
          <Button type="submit" style={{ width: "100%" }}>
            Next Step
            <i className="bi bi-arrow-right ml-2" />
          </Button>
        </Form.Group>
      </Stack>
    </Form>
  );

  // effects
  useEffect(() => {
    if (register.data !== null) dispatch(resetRegisterAction());
  }, [dispatch]);

  useEffect(() => {
    if (!emailChecker.processing) {
      const target = emailChecker.data?.target;
      const isTargetTaken = emailChecker.data?.isTargetTaken;
      if (values.email === target) {
        isTargetTaken
          ? setFieldError("email", "This email has already been taken!")
          : navigate("/sign-up-step", { state: { ...state, ...values } });
      }
    }
  }, [emailChecker.processing]);

  useLayoutEffect(() => {
    document.title = `Sign up - 1/3 | ${APP_TITLE_SUFFIX}`;
  }, []);
  // render
  return (
    <Stack gap={4} className={styles.container}>
      <Stack>
        <h2>
          <b>Welcome to Cursus</b>
        </h2>
        <span>Sign Up and Start Learning!</span>
      </Stack>
      {signUpForm}
      <div>
        Already have an account? <Link to={"/sign-in"}>Sign In</Link>
      </div>
    </Stack>
  );
};

/* required: display name */
SignUp.displayName = "SignUp";

/* required: props types */
SignUp.propTypes = {};

/* required: default props */
SignUp.defaultProps = {};

export { SignUp };
